import { useEffect, useState } from 'react'

export function useTaDraft(key, initialValue) {
  const [value, setValue] = useState(() => {
    try {
      const saved = sessionStorage.getItem(`ta-draft:${key}`)
      return saved ? { ...initialValue, ...JSON.parse(saved) } : initialValue
    } catch {
      return initialValue
    }
  })

  useEffect(() => {
    try { sessionStorage.setItem(`ta-draft:${key}`, JSON.stringify(value)) } catch {}
  }, [key, value])

  const clear = (nextValue = initialValue) => {
    setValue(nextValue)
    try { sessionStorage.removeItem(`ta-draft:${key}`) } catch {}
  }
  return [value, setValue, clear]
}
